import { useContext } from "react";

import { ReadLayerContext } from "./ReadLayerQueryContext";
import Select, { SingleValue } from "react-select";

interface ColumnDropdownProps {
  options: ColumnDropdownOption[];
  column: string;
  placeholder: string;
}

interface ColumnDropdownOption {
  label: string;
  value: string;
}

export const ColumnDropdown = ({
  column,
  options,
  placeholder
}: ColumnDropdownProps) => {
  const ctx = useContext(ReadLayerContext);

  if (!ctx) return null;

  const { addFilter, query } = ctx;

  const handleOnDateChange = (
    item: SingleValue<{ label: string; value: string }>
  ) => {
    addFilter({
      column,
      value: item?.value ?? "",
      displayValue: item?.value ?? ""
    });
  };

  return (
    <>
      <Select
        placeholder={placeholder}
        options={options}
        isSearchable
        isClearable
        onChange={handleOnDateChange}
        value={
          query.filters.find(x => x.column === column) == undefined
            ? null
            : options.find(
                x =>
                  x.value ==
                  query.filters.find(x => x.column === column)?.displayValue
              )
        }
      />
    </>
  );
};
